import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[cmDataLabel]',
    standalone: false
})
export class CmDataLabelDirective {
	@HostBinding('attr.data-label') @Input() cmDataLabel: string;

	constructor() {}
}
